module.exports = __webpack_public_path__ + "static/whistle-game.477b59f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whistle-game.jpg
// module id = 994
// module chunks = 263791100135453